module.exports = __webpack_public_path__ + "img/winning-narratives.ae1dedc9.svg";